import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProductIntegrationComponent } from './product-integration.component';

const routes: Routes = [
  {
    path: ':id',
    component: ProductIntegrationComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProductIntegrationRoutingModule { }
